import { baseApi } from "./baseApi";

const complaintApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getComplaints: builder.query({
      query: (params) => {
        let url = "complaints";

        url += "?";

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }

        if (params.status) {
          url += `status=${params.status}&`;
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.city_id) {
          url += `city_id=${params.city_id}&`;
        }
        if (params.contact_number) {
          url += `contact_number=${params.contact_number}&`;
        }
        if (params.brand_booking_status) {
          url += `brand_booking_status=${params.brand_booking_status}&`;
        }
        if (params.customer_name) {
          url += `customer_name=${params.customer_name}&`;
        }
        if (params.assigned_city_manager_id) {
          url += `assigned_city_manager_id=${params.assigned_city_manager_id}&`;
        }
        if (params.zone_id) {
          url += `zone_id=${params.zone_id}&`;
        }
        if (params.partner_id) {
          url += `partner_id=${params.partner_id}&`;
        }
        if (params.agent_id) {
          url += `agent_id=${params.agent_id}&`;
        }
        if (params.brand_complaint_code) {
          url += `brand_complaint_code=${params.brand_complaint_code}&`;
        }
        if (params.ecb_code) {
          url += `ecb_code=${params.ecb_code}&`;
        }
        if (params.start_date) {
          url += `start_date=${params.start_date}&`;
        }
        if (params.end_date) {
          url += `end_date=${params.end_date}&`;
        }
        if (params.next_follow_up_start) {
          url += `next_follow_up_start=${params.next_follow_up_start}&`;
        }
        if (params.next_follow_up_end) {
          url += `next_follow_up_end=${params.next_follow_up_end}&`;
        }
        if (params.unassigned) {
          url += "unassigned=true&";
        }

        if (params.unassigned === false) {
          url += "unassigned=false&";
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getComplaintById: builder.query({
      query: (id) => `complaints/${id}`
    }),
    createComplaint: builder.mutation({
      query: (data) => ({
        url: "complaints",
        method: "POST",
        body: data
      })
    }),
    updateComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.complaint?.id}`,
        method: "PUT",
        body: data
      })
    }),
    // {{Server}}/api/v1/complaints/84/cancel?reason=CustomerRefused
    cancelComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.id}/cancel?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    // {{Server}}/api/v1/complaints/84/on_hold?reason=DealerRequest
    onHoldComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.id}/on_hold?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    closeComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.id}/close?close_reason=${data?.close_reason}&close_complaint_summary=${data?.close_complaint_summary}`,
        method: "PUT"
      })
    }),
    deleteComplaint: builder.mutation({
      query: (id) => ({
        url: `complaints/${id}`,
        method: "DELETE"
      })
    }),
    createCustomerConnectLogForComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.id}/add_customer_connect_log`,
        method: "POST",
        body: data
      })
    }),
    updateCustomerConnectLogForComplaint: builder.mutation({
      query: (data) => ({
        url: `complaints/${data?.id}/edit_customer_connect_log`,
        method: "PUT",
        body: data
      })
    }),
    getCustomerConnectLogsForComplaint: builder.query({
      query: (id) => ({
        url: `complaints/${id}/customer_connect_logs`,
        method: "GET"
      })
    })
  })
});

export const {
  useGetComplaintsQuery,
  useLazyGetComplaintByIdQuery,
  useCreateComplaintMutation,
  useUpdateComplaintMutation,
  useCancelComplaintMutation,
  useCloseComplaintMutation,
  useOnHoldComplaintMutation,
  useDeleteComplaintMutation,
  useCreateCustomerConnectLogForComplaintMutation,
  useGetCustomerConnectLogsForComplaintQuery,
  useUpdateCustomerConnectLogForComplaintMutation
} = complaintApi;
